import { call, put, select, take, takeEvery } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'
import * as actions from './actions'

const delay = (time: number) => new Promise(resolve => setTimeout(resolve, time))

function* resetLastUpdate() {
  try {
    yield call(delay, 10000)
    yield put(actions.resetLastImportAction())
  } catch (e) {
    console.log(e)
  }
}

function* productSaga() {
  yield takeEvery(getType(actions.createProductFromFileAction.success), resetLastUpdate)
}

export default productSaga
